import React, { Component } from 'react';
import Navbar from './Navbar';
import Slider from './Slider';
import Timeline from './Timeline';
import Certificates from './Certificates';
import About from './About';
import Offers from './Offers';
import News from './News';
import Contact from './Contact';

const HomePage = props => (
		<div>
			<section className="about-section" id="about">    
	          <About />
	        </section>

	        <section className="offers bg-gray" id="offer">
	          <Offers />
	        </section>

	        <section className="certificates">
	          <Certificates />
	        </section>
	        <Contact />
        </div>
	);

export default HomePage;